<template>
  <div
    v-show="alert.active"
    class="alert"
    :style="{ backgroundColor: alert.color }"
  >
    <div class="message">{{ alert.message }}</div>
    <div class="item--close" @click="closeModal">
      <font-awesome-icon id="btn-icon" icon="times" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["alert"]),
  methods: {
    closeModal() {
      this.$store.commit("closeAlert");
    }
  }
};
</script>

<style scoped>
.alert {
  width: 25%;
  min-height: 40px;
  border-radius: 20px;
  position: fixed;
  right: 20px;
  top: 20px;
  color: white;
  font-weight: 400;
  display: grid;
  grid-template-columns: 85% 10%;
  align-items: center;
  column-gap: 5%;
  -webkit-box-shadow: 22px 24px 38px -9px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 22px 24px 38px -9px rgba(0, 0, 0, 0.75);
  box-shadow: 22px 24px 38px -9px rgba(0, 0, 0, 0.75);
  z-index: 9999;
}

.message {
  margin-left: 5%;
  padding-left: 5%;
}
.item--close,
.btn-icon {
  cursor: pointer;
}
</style>
